import {trialSvg as Icon__small__trialSvg} from '../Icon__small/Icon__small--trial.js';

export var trial = {
  name: 'trial',
  category: 'icon',
  colorable: true,
  svg: Icon__small__trialSvg,
};
